import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ConnectSection } from '../sections';

/**
 * Main Layout Component
 * Wraps all pages with a consistent header, footer, and a global
 * "Let's Connect" lead-capture strip mounted immediately above the
 * footer.
 *
 * ConnectSection is intentionally rendered here (not per-page) so:
 *   - Every route gets the CTA "for free" — including the placeholder
 *     `/blog`, `/case-studies`, and `/resources/*` NotFound routes.
 *   - The Contact page (`/contact`) already ships a richer contact +
 *     RFP form, so we suppress the global strip there to avoid two
 *     identical CTAs stacked on the same page.
 */
export const Layout: React.FC = () => {
  const location = useLocation();
  // Trim trailing slash so `/contact` and `/contact/` both match.
  const path = location.pathname.replace(/\/+$/, '');
  const showConnectStrip = path !== '/contact';

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      {showConnectStrip && <ConnectSection />}
      <Footer />
    </div>
  );
};

